import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../components/global/DynamicIcon";
import ItemStatus from "../../../../../../common/components/item_status";

type Props = {
  onActionViewItem: (idChecklist: number, openNewTab: boolean) => void;
  onActionEditar: (idChecklist: number | null, openState: boolean) => void;
  onActionDeletar: (idChecklist: number | null, openState: boolean) => void;
};

export const GenerateProjetoColumnDefinition = ({ onActionEditar, onActionDeletar, onActionViewItem }: Props): GridColDef[] => {
   const computeItemStatusColor = (status: boolean) => {
    switch (status) {
      case true:
        return "green";
        case false:
        return "red";
      default:
        return "gray";
    }
  };

  const computeItemStatusTitle = (status: boolean) => {
    switch (status) {
      case true:
        return "A";
      case false:
        return "I";
      default:
        return "NA";
    }
  };
  const computeItemStatusDescription = (status: boolean) => {
    switch (status) {
      case true:
        return "Ativo";
      case false:
        return "Inativo";
      default:
        return "Não Informada";
    }
  };
  return [
     {
      field: "Status",
      filterable: false,
      headerName: "Status",
      maxWidth: 100,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)}
          />
        </div>
      ),
    },
    {
      field: "Nome",
      headerName: "Nome",
      flex: 1,
      minWidth: 150,
      sortable: false,
      filterable: false,
      headerClassName: "projeto-header",
    },
    {
      field: "itens",
      filterable: false,
      headerName: "Itens",
      sortable: false,
      valueGetter: (_, row) => {
        return row["IdChecklist"] as number;
      },
      renderCell: ({ value }) => {
        return (
          <Button
            onMouseDown={(e) => {
              if (e.button === 1) {
                onActionViewItem(value, true);
              } else {
                onActionViewItem(value, e.ctrlKey);
              }
              e.preventDefault();
            }}
            sx={{
              fontSize: 11,
              paddingX: ".4rem",
              paddingY: 0,
              background: "#e6e6e6",
              borderLeft: ".2rem solid #45b6af",
              borderRadius: 0,
              color: "black",
              fontWeight: "normal",
            }}
          >
            Itens
          </Button>
        );
      },
    },
    {
      field: "IdChecklist",
      headerName: "Ações",
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton onClick={() => onActionEditar(params.value, true)}>
            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
          </IconButton>
          <IconButton onClick={() => onActionDeletar(params.value, true)}>
            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
          </IconButton>
        </div>
      ),
    },
  ];
};
